import { BButton, BCol, BIcon, BRow, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import React, { useEffect, Fragment } from 'react'

import { appActions } from '../../redux'
import { intl, IntlInterface } from '../../hoc'
import { reloadPage } from '../../utils/url'
import messages from '../../i18n'
import styles from './styles.module.css'

interface Props extends IntlInterface {
  setSessionExpired: Function
}

export const InactivityDialogLogout = ({ setSessionExpired, translate }: Props) => {
  useEffect(() => {
    setSessionExpired()
  }, [setSessionExpired])

  return (
    <Fragment>
      <BRow>
        <BCol theme="text-center">
          <BIcon name="clock" theme={styles.clockSize} />
          <BTitle type="h2" center>
            {translate(messages.inactivityDialogLogout.title)}
          </BTitle>
          <BText>{translate(messages.inactivityDialogLogout.subtitle)}</BText>
        </BCol>
      </BRow>
      <BRow>
        <BCol theme="text-center">
          <BButton
            color="primary"
            messages={{ message: translate(messages.inactivityDialogLogout.button) }}
            onClick={reloadPage}
            testid="close"
          />
        </BCol>
      </BRow>
    </Fragment>
  )
}

export default compose(
  connect(null, {
    setSessionExpired: appActions.setSessionExpired,
  }),
  intl
)(InactivityDialogLogout)
